import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Popover,
  Box,
  MenuItem,
  Select,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  MapIssueLog,
  MapManageUser,
} from "../../../components/Table/mapping-function/TableMapping";
import { PackageTable } from "../../../components/Table/component/PackageTable";
import { useEffect, useState } from "react";
import {
  FilterIkn,
  OffIkn,
  OnIkn,
  SearchIcon,
} from "../../../utils/icon/Private-Pages/Icon";
import http from "../../../utils/http-common";
import { toast } from "react-toastify";
import DownloadIcon from "@mui/icons-material/Download";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
export const ManageUsers = () => {
  const cellStyle = {
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16px",
    textAlign: "left",
  };
  const dataStyle = {
    fontFamily: "Inter, sans-serif",
    fontSize: "10px",
    fontWeight: 500,
    lineHeight: "18px",
    textAlign: "left",
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [tableData, setTableData] = useState(MapManageUser([]));
  const [allData, setAllData] = useState([]);

  const [filter1, setFilter1] = useState(null);
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [threedotss, setThreeDotss] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getPlan();
  }, []);
  const getPlan = async () => {
    try {
      const response = await http.post("/auth_service/admin/user/list");
      const data = response.data.data
        .map((i) => ({
          user_id: i.user_id.toString(),
          user_name: i.user_name,
          email_id: i.email,
          subscription_type: i.subscription_name,
          plans_associated: i.plan_count,
          joined_on: new Date(i.createdAt).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
          }),
          logined_on: new Date(i.updatedAt).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
          }),
          verified_status: i.verified,
          user_status: i.user_status,
        }))
        .sort((a, b) => new Date(b.joined_on) - new Date(a.joined_on));
      setAllData(data);
      setTableData(MapManageUser(data));
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedData = [...allData].sort((a, b) => {
      if (key === "joined_on" || key === "logined_on") {
        return direction === "asc"
          ? new Date(a[key]) - new Date(b[key])
          : new Date(b[key]) - new Date(a[key]);
      }
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setTableData(MapManageUser(sortedData));
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return "↕";
    return sortConfig.direction === "asc" ? "↑" : "↓";
  };

  const filteredData = tableData.filter((item) =>
    Object.values(item).some((value) =>
      String(value?.props?.txt || value || "")
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    )
  );
  const btns = [
    {
      title: ({ i, rowData }) => {
        const statusText = rowData.user_status?.props?.txt;
        return statusText === "Active" ? (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <OffIkn />
            <Typography sx={{ pl: 1 }}>Deactivate User</Typography>
          </Box>
        ) : (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <OnIkn />
            <Typography sx={{ pl: 1 }}>Activate User</Typography>
          </Box>
        );
      },
      fn: async ({ index, i, rowData }) => {
        try {
          const statusText = rowData?.user_status.props.txt;
          let status;
          if (
            statusText === "Deactivated" ||
            statusText === "Pending" ||
            statusText === "Draft"
          ) {
            status = "Active";
          } else if (statusText === "Active") {
            status = "Inactive";
          } else {
            status = statusText; // fallback in case of unexpected status
          }
          const payload = {
            user_id: parseInt(rowData.user_id),
            status: status,
          };

          const response = await http.post(
            "/auth_service/admin/user/status/update",
            payload
          );
          toast.success("User status updated successfully");
          getPlan();
        } catch (error) {
          console.error("Error updating user status:", error);
          toast.error("Failed to update user status");
        }
      },
      cb: true,
      link: "",
    },
  ];
  const [anchorEl, setAnchorEl] = useState(null);
  const handleCloseAction = () => {
    setAnchorEl(null);
    setOpen(false);
    setSelectedUser(null);
  };
  const handleActionOpen = (event, userId, userDetails) => {
    setSelectedUser(userDetails);
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };
  const handleExportExcel = async () => {
    try {
      const response = await http.post("/auth_service/admin/user/list");
      const userData = response.data.data
        .map((user) => ({
          "User ID": user.user_id,
          "User Name": user.user_name,
          Email: user.email,
          "Subscription Type": user.subscription_name,
          "Plans Associated": user.plan_count,
          "Joined On": new Date(user.createdAt).toLocaleDateString("en-GB"),
          "Last Login": new Date(user.updatedAt).toLocaleDateString("en-GB"),
          "Verified Status": user.verified ? "Verified" : "Not Verified",
          "User Status": user.user_status,
        }))
        .sort((a, b) => new Date(b["Last Login"]) - new Date(a["Last Login"]));

      // Create a new workbook and worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Users");

      // Add header row
      const headers = Object.keys(userData[0]);
      worksheet.addRow(headers);

      // Add user data rows
      userData.forEach((user) => {
        worksheet.addRow(Object.values(user));
      });

      // Optional: style headers
      headers.forEach((header, idx) => {
        const cell = worksheet.getCell(1, idx + 1);
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF4F81BD" },
        };
        cell.alignment = { vertical: "middle", horizontal: "center" };
      });

      // Auto-size columns
      worksheet.columns.forEach((column) => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const columnLength = cell.value ? cell.value.toString().length : 10;
          maxLength = Math.max(maxLength, columnLength);
        });
        column.width = maxLength + 2;
      });

      // Export to file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "users_list.xlsx");
    } catch (error) {
      console.error("Error exporting data:", error);
      toast.error("Failed to export user data");
    }
  };
  const handleFilterChange = (value) => {
    setFilter1(value);
    if (value === "all") {
      getPlan(); // Reset to show all users
      return;
    }

    // Filter users based on subscription type
    const filteredUsers = allData.filter((user) => {
      if (value === "Paid") {
        return (
          user.subscription_type !== "Free" && user.subscription_type !== null
        );
      } else if (value === "Free") {
        return user.subscription_type !== "Paid";
      }
      return true;
    });

    setTableData(MapManageUser(filteredUsers));
  };
  const prop = {
    // title: 'Manage User',
    borderBoxStyle: { px: 0 },
    goto: true,
    // searchTerm,
    // setSearchTerm,
    filteredData: filteredData,
    // filteredData: tableData,
    titleStyle: { fontSize: "20px", fontWeight: "600", color: "#000" },
    rowsPerPage,
    page,
    setPage,
    tableProps: { btnData: btns },
    tableStyle: {
      Invoice: false,
      isThreeDot2: threedotss,
      OutBox: {
        borderRadius: "8px",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
      threeDot2: { textAlign: "end" },
    },
  };
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}>
        <Typography
          sx={{ color: "#000000", fontSize: "20px", fontWeight: "600" }}>
          Manage User
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton
            onClick={handleExportExcel}
            sx={{
              height: "35px",
              width: "35px",
              border: "0.8px solid #797F8F80",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}>
            <DownloadIcon sx={{ color: "#757575" }} />
          </IconButton>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "0.8px solid #797F8F80",
              borderRadius: "4px",
              padding: "0rem 1rem",
              width: "100%",
              height: "35px",
              maxWidth: "250px",
            }}>
            <SearchIcon sx={{ color: "#757575", marginRight: "0.5rem" }} />
            <TextField
              sx={{
                flex: 1,
                "& .MuiOutlinedInput-root": {
                  lineHeight: "35px",
                  height: "35px",
                  "& fieldset": { border: "none", height: "35px" },
                  "&:hover fieldset": { border: "none" },
                  "&.Mui-focused fieldset": { border: "none" },
                },
              }}
              placeholder='Search...'
              variant='outlined'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Box>
          <Select
            displayEmpty
            size='small'
            value={filter1}
            onChange={(e) => handleFilterChange(e.target.value)}
            inputProps={{ IconComponent: () => null }}
            sx={{
              width: "170px",
              height: "40px",
              pr: "5px !important",
              "& .MuiSelect-select": {
                display: "flex",
                alignItems: "center",
                justifyContent: filter1 === null ? "end" : "center",
                pl: 0,
                pr: "5px !important",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#D0D5DD",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#D0D5DD",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#D0D5DD",
              },
              "&.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
                {
                  pr: 0,
                },
            }}>
            <MenuItem sx={{ display: "none" }} value={null} disabled>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  width: "100%",
                }}>
                <FilterIkn />
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "#797F8F",
                  }}>
                  User Status
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem
              value='all'
              sx={{ fontSize: "12px", fontWeight: "400", color: "#797F8F" }}>
              All
            </MenuItem>
            <MenuItem
              value='Paid'
              sx={{ fontSize: "12px", fontWeight: "400", color: "#797F8F" }}>
              Paid
            </MenuItem>
            <MenuItem
              value='Free'
              sx={{ fontSize: "12px", fontWeight: "400", color: "#797F8F" }}>
              Not Paid
            </MenuItem>
          </Select>
        </Box>
      </Box>
      {/* <PackageTable prop={prop} /> */}
      <TableContainer component={Paper} style={{ overflowX: "auto" }}>
        <Table sx={{ minWidth: 150 }} aria-label='user table' size='small'>
          <TableHead sx={{ backgroundColor: "#e0eaff", height: "50px" }}>
            <TableRow>
              <TableCell
                sx={cellStyle}
                onClick={() => handleSort("user_id")}
                style={{ cursor: "pointer" }}>
                User ID {getSortIcon("user_id")}
              </TableCell>
              <TableCell
                sx={cellStyle}
                onClick={() => handleSort("user_name")}
                style={{ cursor: "pointer" }}>
                User Name {getSortIcon("user_name")}
              </TableCell>
              <TableCell
                sx={cellStyle}
                onClick={() => handleSort("email_id")}
                style={{ cursor: "pointer" }}>
                Email ID {getSortIcon("email_id")}
              </TableCell>
              <TableCell
                sx={cellStyle}
                onClick={() => handleSort("subscription_type")}
                style={{ cursor: "pointer" }}>
                Subscription Type {getSortIcon("subscription_type")}
              </TableCell>
              <TableCell
                sx={cellStyle}
                onClick={() => handleSort("joined_on")}
                style={{ cursor: "pointer" }}>
                Joined On {getSortIcon("joined_on")}
              </TableCell>
              <TableCell
                sx={cellStyle}
                onClick={() => handleSort("logined_on")}
                style={{ cursor: "pointer" }}>
                Logined On {getSortIcon("logined_on")}
              </TableCell>
              <TableCell
                sx={cellStyle}
                onClick={() => handleSort("verified_status")}
                style={{ cursor: "pointer" }}>
                Verified Status {getSortIcon("verified_status")}
              </TableCell>
              <TableCell
                sx={cellStyle}
                onClick={() => handleSort("user_status")}
                style={{ cursor: "pointer" }}>
                User Status {getSortIcon("user_status")}
              </TableCell>
              <TableCell sx={cellStyle}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData
              .slice((page - 1) * rowsPerPage, page * rowsPerPage)
              .map((user) => (
                <TableRow key={user.user_id}>
                  <TableCell sx={dataStyle}>{user.user_id}</TableCell>
                  <TableCell sx={dataStyle}>{user.user_name}</TableCell>
                  <TableCell sx={dataStyle}>{user.email_id}</TableCell>
                  <TableCell sx={dataStyle}>{user.subscription_type}</TableCell>
                  <TableCell sx={dataStyle}>{user.joined_on}</TableCell>
                  <TableCell sx={dataStyle}>{user.logined_on}</TableCell>
                  <TableCell sx={dataStyle}>{user.verified_status}</TableCell>
                  <TableCell sx={dataStyle}>{user.user_status}</TableCell>
                  <TableCell>
                    <IconButton
                      aria-label='more options'
                      onClick={(event) =>
                        handleActionOpen(event, user.user_id, user)
                      }>
                      <MoreVertIcon sx={{ height: "20px", width: "20px" }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
          <Popover
            id={`user-action-menu-${selectedUser?.user_id}`}
            open={open}
            anchorEl={anchorEl}
            onClose={handleCloseAction}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}>
            <Box sx={{ p: 1, width: "200px" }}>
              {selectedUser && (
                <Box
                  onClick={() => {
                    btns[0].fn({ rowData: selectedUser });
                    handleCloseAction();
                  }}
                  sx={{
                    p: 1,
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                    },
                    display: "flex",
                    alignItems: "center",
                  }}>
                  {btns[0].title({ rowData: selectedUser })}
                </Box>
              )}
            </Box>
          </Popover>
        </Table>
        <TablePagination
          component='div'
          count={filteredData.length}
          page={page - 1}
          onPageChange={(event, newPage) => setPage(newPage + 1)}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10]}
        />
      </TableContainer>
    </Box>
  );
};
